var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{staticClass:"public-portfolio-hero-connections",attrs:{"disabled":!_vm.$auth.loggedIn},on:{"click":_setup.showConnections}},[_vm._v("\n  "+_vm._s(_setup.buttonWording)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }